import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationCardHepsiburadaIcon() {
  return (
    <IconWrapper sx={{ width: 15, height: 15 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 93 93"
        style={{
          filter: "none",
          width: "100%"
        }}
      >
        <defs>
          <clipPath id="clip-path">
            <path
              id="Path_17"
              data-name="Path 17"
              d="M26,0H67A26,26,0,0,1,93,26V67A26,26,0,0,1,67,93H26A26,26,0,0,1,0,67V26A26,26,0,0,1,26,0Z"
              transform="translate(3829 26)"
              fill={"#fff"}
            />
          </clipPath>
        </defs>
        <g id="Group_19" data-name="Group 19" transform="translate(-3829 -26)">
          <g
            id="Mask_Group_5"
            data-name="Mask Group 5"
            clipPath="url(#clip-path)"
          >
            <g
              id="Group_18"
              data-name="Group 18"
              transform="translate(3198 13)"
            >
              <path
                id="Path_17-2"
                data-name="Path 17"
                d="M26,0H67A26,26,0,0,1,93,26V67A26,26,0,0,1,67,93H26A26,26,0,0,1,0,67V26A26,26,0,0,1,26,0Z"
                transform="translate(631 13)"
                fill={"#fff"}
              />
            </g>
            <path
              id="Path_35"
              data-name="Path 35"
              d="M0,0H10.393V11H0Z"
              transform="translate(3832.577 109)"
              fill={"#7623e2"}
            />
            <path
              id="Path_36"
              data-name="Path 36"
              d="M0,0H13.021V11H0Z"
              transform="translate(3842.97 109)"
              fill={"#50bde2"}
            />
            <path
              id="Path_38"
              data-name="Path 38"
              d="M0,0H11.979V11H0Z"
              transform="translate(3882.443 109)"
              fill={"#f09f28"}
            />
            <path
              id="Path_39"
              data-name="Path 39"
              d="M0,0H11.979V11H0Z"
              transform="translate(3894.443 109)"
              fill={"#6b1e5b"}
            />
            <path
              id="Path_40"
              data-name="Path 40"
              d="M0,0H11.979V11H0Z"
              transform="translate(3906.443 109)"
              fill={"#39be9e"}
            />
            <path
              id="Path_37"
              data-name="Path 37"
              d="M0,0H26.473V11H0Z"
              transform="translate(3855.97 109)"
              fill={"#f75f1f"}
            />
          </g>
          <g
            id="Group_15"
            data-name="Group 15"
            transform="translate(20.019 96.11)"
          >
            <path
              id="Path_25"
              data-name="Path 25"
              d="M1225.281-940.5c0,1.825-.02,3.65.012,5.475.009.534-.144.727-.687.7a14.913,14.913,0,0,0-2.013,0c-.612.047-.788-.151-.78-.766.035-2.614.015-5.228.015-7.843,0-2.818.038-5.636-.023-8.452-.018-.839.26-1.051,1.024-.968a6.393,6.393,0,0,0,1.486,0c.718-.091.928.205.836.863a5.457,5.457,0,0,0-.006.763c.172.1.24-.019.293-.1,1.757-2.729,6.8-2.53,8.5,1.23a9.2,9.2,0,0,1-.117,7.857,5.251,5.251,0,0,1-6.661,2.613A6.834,6.834,0,0,1,1225.281-940.5Zm-.139-4.991a4.9,4.9,0,0,0,.21,1.706,2.777,2.777,0,0,0,2.508,2.089,2.618,2.618,0,0,0,2.819-1.749,5.8,5.8,0,0,0-.083-4.647,2.5,2.5,0,0,0-2.508-1.545,2.534,2.534,0,0,0-2.484,1.589A6.227,6.227,0,0,0,1225.142-945.489Z"
              transform="translate(2623.378 912.582)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_26"
              data-name="Path 26"
              d="M1070.433-972.6a5.675,5.675,0,0,1,5.379-1.119,3.728,3.728,0,0,1,2.916,3.489c.225,3.073.041,6.153.109,9.229.011.477-.185.6-.611.591-.756-.016-1.515-.034-2.27,0-.538.026-.688-.165-.682-.693.027-2.294.014-4.588.009-6.882a8.513,8.513,0,0,0-.057-1.041c-.162-1.284-.646-1.868-1.663-2.041a2.6,2.6,0,0,0-2.775,1.368,5.452,5.452,0,0,0-.416,2.466c-.013,2.022-.03,4.044,0,6.066.007.541-.077.8-.7.746a11.7,11.7,0,0,0-2.092,0c-.594.057-.665-.19-.664-.688q.021-8.319,0-16.639c0-.51.1-.739.669-.7a17.239,17.239,0,0,0,2.1,0c.527-.027.7.134.69.685-.038,1.53-.011,3.063-.006,4.594C1070.367-973.022,1070.4-972.883,1070.433-972.6Z"
              transform="translate(2751.087 933.826)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_27"
              data-name="Path 27"
              d="M1149.012-945.2c-1.4,0-2.8.02-4.2-.012-.521-.012-.674.164-.589.653a2.81,2.81,0,0,0,2.049,2.46,2.978,2.978,0,0,0,3.368-.751,1.5,1.5,0,0,1,1.4-.6,14.808,14.808,0,0,0,1.836-.007c.744-.05.776.273.516.826a5.982,5.982,0,0,1-5.167,3.481,7.411,7.411,0,0,1-2.942-.257c-2.441-.733-4.083-2.207-4.447-4.81-.354-2.537-.305-5.044,1.644-7.014,2.128-2.152,4.779-2.329,7.467-1.392,2.458.857,3.56,2.865,3.778,5.374.178,2.05.162,2.052-1.918,2.052Zm-1.856-2.277c.813,0,1.628-.023,2.44.008.522.02.65-.131.517-.648a2.811,2.811,0,0,0-2.892-2.152,2.771,2.771,0,0,0-2.85,2.2c-.119.442-.094.628.433.6C1145.586-947.5,1146.372-947.474,1147.156-947.474Z"
              transform="translate(2690.274 912.978)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M1300.644-943.947a5.745,5.745,0,0,0,.612,0c.691-.074,1.219,0,1.363.867.092.552.618.83,1.145.968a5.131,5.131,0,0,0,2.682.036c.523-.142,1-.373,1.019-1.027a1.066,1.066,0,0,0-.924-1.1c-1.177-.329-2.359-.636-3.538-.959-.336-.092-.669-.2-1-.311-1.509-.516-2.66-1.353-2.721-3.113a3.944,3.944,0,0,1,2.179-3.888,7.523,7.523,0,0,1,7.441.255,3.872,3.872,0,0,1,1.677,2.93c.075.393-.16.428-.457.424-.526-.007-1.051,0-1.576,0-.726,0-1.365.13-1.723-.9-.371-1.061-3.063-1.185-3.821-.311a.921.921,0,0,0,.522,1.558c1.11.346,2.25.6,3.38.879a9.3,9.3,0,0,1,1.813.619,3.477,3.477,0,0,1,2.247,3.057,3.735,3.735,0,0,1-2.052,3.84,8.726,8.726,0,0,1-7.84,0,3.979,3.979,0,0,1-2.126-2.931c-.151-.675-.019-.995.737-.9a7.746,7.746,0,0,0,.962.007Z"
              transform="translate(2559.82 913.127)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_33"
              data-name="Path 33"
              d="M1379.051-944.259c0,1.974-.021,3.949.013,5.922.009.539-.153.717-.681.694-.726-.032-1.455-.033-2.181,0-.54.024-.676-.181-.673-.706q.034-5.922,0-11.844c0-.492.135-.662.636-.637a21.39,21.39,0,0,0,2.275,0c.523-.03.625.178.619.65C1379.038-948.207,1379.051-946.233,1379.051-944.259Z"
              transform="translate(2496.631 911.059)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_34"
              data-name="Path 34"
              d="M1.9.346a2,2,0,1,1-2,2A2,2,0,0,1,1.9.346Z"
              transform="translate(3871.981 -45.11)"
              fill={"#fd5c1f"}
            />
          </g>
          <g
            id="Group_16"
            data-name="Group 16"
            transform="translate(-47.415 119.08)"
          >
            <path
              id="Path_23"
              data-name="Path 23"
              d="M1408.983-962.086c-.15,1.512-.15,1.512-1.563,1.516-1.909,0-1.909,0-1.909-1.877,0-5.1.013-10.207-.016-15.311,0-.652.161-.871.821-.813a12.627,12.627,0,0,0,2.009,0c.564-.04.68.184.673.7-.027,1.842-.011,3.685-.011,5.736a4.843,4.843,0,0,1,3.392-1.879,5.123,5.123,0,0,1,5.472,3.573,9.128,9.128,0,0,1-.482,7.5,5.121,5.121,0,0,1-6.414,2.445A4.441,4.441,0,0,1,1408.983-962.086Zm5.787-4.858a6.057,6.057,0,0,0-.478-2.531,2.489,2.489,0,0,0-2.422-1.523,2.479,2.479,0,0,0-2.526,1.5,5.919,5.919,0,0,0,.023,4.879,2.583,2.583,0,0,0,2.673,1.558,2.527,2.527,0,0,0,2.35-1.766A5.243,5.243,0,0,0,1414.769-966.943Z"
              transform="translate(2479.939 933.945)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M1697.909-962.6a5.064,5.064,0,0,1-2.681,1.963,5.229,5.229,0,0,1-6.2-3.284,9.221,9.221,0,0,1,.2-7.358,5.085,5.085,0,0,1,8.529-1.322c0-1.892.031-3.673-.016-5.452-.018-.68.169-.937.866-.854.857.1,1.979-.361,2.515.187.49.5.131,1.6.133,2.436.011,4.843-.008,9.685.021,14.528,0,.681-.171.939-.868.863a7.024,7.024,0,0,0-1.567,0c-.78.092-1.067-.2-.934-.959A5.681,5.681,0,0,0,1697.909-962.6Zm-5.929-4.746a5.179,5.179,0,0,0,.421,2.335,2.449,2.449,0,0,0,2.195,1.6,2.517,2.517,0,0,0,2.641-1.321,5.507,5.507,0,0,0-.046-5.331,2.5,2.5,0,0,0-2.485-1.309,2.483,2.483,0,0,0-2.285,1.611A5.494,5.494,0,0,0,1691.98-967.348Z"
              transform="translate(2246.617 934.289)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_28"
              data-name="Path 28"
              d="M1623.014-940.464a6.675,6.675,0,0,1-3.257,1.777c-3.391.607-5.821-2.078-4.79-5.32a3.572,3.572,0,0,1,2.138-2.26,11.083,11.083,0,0,1,2.966-.678c.461-.061.928-.1,1.383-.19.719-.146,1.493-.276,1.526-1.241.026-.757-.553-1.207-1.642-1.338a2.255,2.255,0,0,0-2.767,1.473.513.513,0,0,1-.54.316c-.786-.006-1.573-.018-2.358,0-.467.013-.519-.2-.451-.592a4.185,4.185,0,0,1,3.236-3.677,9.09,9.09,0,0,1,5.9.387,3,3,0,0,1,2,2.892c.047,3.1.024,6.2.053,9.3,0,.486-.2.587-.624.564-.464-.025-.931-.005-1.4-.005C1623.119-939.053,1623.119-939.053,1623.014-940.464Zm-.133-4.864a27.635,27.635,0,0,1-3.355.867,1.678,1.678,0,0,0-1.274,2.135c.2.868.856,1.267,1.936,1.17C1622.346-941.349,1623.276-942.765,1622.881-945.328Z"
              transform="translate(2307.351 912.44)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_29"
              data-name="Path 29"
              d="M1782.52-942.336q0,1.583-.008,3.166c-.784.016-1.572-.008-2.351.059-.683.059-.975-.16-.86-.853a3.246,3.246,0,0,0-.027-.555c-.356.271-.616.471-.878.669a5.179,5.179,0,0,1-4.516,1.006,3.561,3.561,0,0,1-2.906-3.262,3.882,3.882,0,0,1,2.34-4.235,18.832,18.832,0,0,1,4.173-.835c1.3-.226,1.738-.578,1.686-1.357s-.676-1.207-1.89-1.261c-1.156-.052-2.173.142-2.5,1.478-.087.355-.364.318-.622.319-.728,0-1.456-.019-2.182.008-.485.018-.587-.168-.521-.62a4.031,4.031,0,0,1,2.9-3.556,8.833,8.833,0,0,1,6.3.338,2.877,2.877,0,0,1,1.854,2.521Zm-3.35-1.973c.012-1.038.012-1.036-1.013-.762-.224.06-.453.1-.679.152-.595.134-1.2.227-1.781.412a1.652,1.652,0,0,0-1.243,2.075c.153.83.779,1.242,1.833,1.206C1778.174-941.289,1779.149-942.332,1779.17-944.308Z"
              transform="translate(2178.489 912.509)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_31"
              data-name="Path 31"
              d="M1495.026-939.807a4.843,4.843,0,0,1-5.217,1.87,3.662,3.662,0,0,1-3.146-3.551c-.3-2.659-.1-5.33-.138-8-.028-1.762-.005-1.762,1.763-1.762,1.816,0,1.816,0,1.816,1.8,0,2.117-.009,4.234,0,6.35.01,1.59.527,2.284,1.773,2.446a2.493,2.493,0,0,0,2.883-1.945,5.9,5.9,0,0,0,.147-1.638c.008-2.088.027-4.176-.011-6.263-.011-.617.176-.82.783-.761.889.087,2.08-.373,2.589.19.441.488.146,1.65.148,2.515.007,3.219-.018,6.437.02,9.656.008.674-.208.875-.839.8a8.042,8.042,0,0,0-.958,0C1495.1-938.1,1495.1-938.1,1495.026-939.807Z"
              transform="translate(2413.126 911.483)"
              fill={"#fd5c1f"}
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M1570.082-950.355a4.057,4.057,0,0,1,3.443-2.3c.533-.017.809.067.755.7a14.026,14.026,0,0,0,0,2.163c.039.57-.187.655-.7.651-2.516-.023-3.436.872-3.469,3.369q-.039,2.955.006,5.91c.008.533-.153.744-.684.7-.916-.081-2.115.378-2.667-.2-.444-.463-.144-1.65-.146-2.515-.007-3.216.017-6.432-.019-9.648-.007-.655.167-.882.822-.806a6.069,6.069,0,0,0,1.4,0c.83-.1,1.278.1,1.1,1.054A1,1,0,0,0,1570.082-950.355Z"
              transform="translate(2347.119 912.563)"
              fill={"#fd5c1f"}
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  )
}
